function ResourceError() {
    return <div className="text-center">
        <h2>Resource not found!</h2>

        <p>It appears that the resource you are trying to locate does not exist.</p>
    </div>
}


export default ResourceError